import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { closeSnackbar } from '../../../redux/slices/snackbarSlice'; 

export default function CustomizedSnackbars() {
  const dispatch = useDispatch();
  const { open, title, subtitle, duration, severity, position } = useSelector((state) => state.snackbar);
  

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(closeSnackbar());
  };
  if (!open || !title) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={position}
      sx={{ zIndex: 2000000 }}
    >
      <Alert
        onClose={handleClose}
        severity={severity} // Dynamically set severity
        variant="filled"
        sx={{
          borderRadius: '10px',  // Rounded corners
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',  // Subtle shadow
          padding: '10px',
          backgroundColor: severity === 'success' ? '#28a745' : '#FFBF00',  // Green for success, orange for warning/error
          color: 'white',
          fontWeight: '500',
          minWidth: '250px', 
          textAlign: 'center', // Centers text
          marginBottom: '2rem', 
        }}
      >
        {title} {subtitle}
      </Alert>
    </Snackbar>
  );
}
